import { render, staticRenderFns } from "./FeesForSecurityPage.vue?vue&type=template&id=b41fd6f2&scoped=true&"
import script from "./FeesForSecurityPage.vue?vue&type=script&lang=js&"
export * from "./FeesForSecurityPage.vue?vue&type=script&lang=js&"
import style0 from "./FeesForSecurityPage.vue?vue&type=style&index=0&id=b41fd6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41fd6f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b41fd6f2')) {
      api.createRecord('b41fd6f2', component.options)
    } else {
      api.reload('b41fd6f2', component.options)
    }
    module.hot.accept("./FeesForSecurityPage.vue?vue&type=template&id=b41fd6f2&scoped=true&", function () {
      api.rerender('b41fd6f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/calculation/feesForSecurity/FeesForSecurityPage.vue"
export default component.exports